import { render, staticRenderFns } from "./wt-ueditor.vue?vue&type=template&id=0ca3a1d2"
import script from "./wt-ueditor.vue?vue&type=script&lang=js"
export * from "./wt-ueditor.vue?vue&type=script&lang=js"
import style0 from "./wt-ueditor.vue?vue&type=style&index=0&id=0ca3a1d2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports